import useJwt from '@/auth/jwt/useJwt'
import store from '@/store'
// import decode from 'jwt-decode'

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  return (
    localStorage.getItem('userData')
    && localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName)
  )
}

// eslint-disable-next-line arrow-body-style
export const selectedProject = () => {
  return store.state.app.projectId === null
}

// eslint-disable-next-line arrow-body-style
export const selectedOrganization = () => {
  return store.state.app.organizationId === null
}

export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

// uncomment if gjirafa front fix is not working
// const token = localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName)
// const decodedAccessToken = decode(token)
// export const expiredToken = () => Date.now() >= decodedAccessToken.exp * 1000

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === 'admin') return '/'
  if (userRole === 'client') return { name: 'access-control' }
  return { name: 'auth-login' }
}
